module.exports = __webpack_public_path__ + "img/slide1_img3.9d488f9e.png";